export const COMPARATOR_OPTIONS = [
  { value: 'GT', label: 'Greater Than' },
  { value: 'LT', label: 'Less Than' },
  { value: 'EQ', label: 'Equals To' },
  { value: 'NOTEQ', label: 'Not Equals To' },
  { value: 'IN', label: 'In' },
  { value: 'NOTIN', label: 'Not In' },
];

export const ARRAY_COMPARATORS = ['IN', 'NOTIN'];

export function coerceScalar(raw: string): string | number {
  const trimmed = raw.trim();
  if (trimmed !== '' && !isNaN(Number(trimmed))) {
    return Number(trimmed);
  }
  return trimmed;
}

export function buildConditionValue(comparator: string, raw: string): any {
  if (ARRAY_COMPARATORS.includes(comparator)) {
    return raw
      .split(',')
      .map((s) => s.trim())
      .filter((s) => s !== '')
      .map(coerceScalar);
  }
  return coerceScalar(raw);
}

export function displayConditionValue(value: any): string {
  if (Array.isArray(value)) {
    return value.join(', ');
  }
  return value !== undefined && value !== null ? String(value) : '';
}
